/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Toggle_Play_PreviewInputs */



/**
* | output |
* | --- |
* | "Toggle play preview on/off" |
*
* @param {Shortcut_Keys_Desc_Toggle_Play_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_toggle_play_preview = /** @type {((inputs?: Shortcut_Keys_Desc_Toggle_Play_PreviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Toggle_Play_PreviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer l'apercu de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiedergabevorschau ein-/ausschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva l'anteprima di riproduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить/выключить предварительный просмотр воспроизведения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar la vista previa de reproducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换播放预览开/关")
	if (locale === "ja") return /** @type {LocalizedString} */ ("再生プレビューのオン/オフを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्ले प्रीव्यू चालू/बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar/desativar a pré-visualização da reprodução")
	return /** @type {LocalizedString} */ ("Toggle play preview on/off")
});